import React from 'react';
import Drawer from '../Drawer/Drawer';
import OffersModal from './OffersModal';

/**
 * Enveloppe d'`OffersModal` pour un affichage GLOBAL, via le ModalManager.
 *
 * Pourquoi elle existe : `OffersModal` n'est pas une modale, c'est une CARTE (`.om` est en
 * `position: relative`). Elle comptait jusqu'ici sur le drawer qui la portait pour l'overlay, le
 * centrage et le verrouillage du scroll. Rendue telle quelle par le ModalManager — qui retourne
 * ses enfants sans aucun habillage — elle atterrissait dans le flux, en bas de page : le clic
 * ouvrait bien la modale, mais rien n'apparaissait à l'écran.
 *
 * On lui rend donc son écrin en instanciant un `<Drawer>` directement, comme le fait déjà
 * StoryViewersModal. Le mécanisme habituel (`openOffersDrawer` dans hooks/useRestriction) ne
 * convenait pas ici : il passe par `openDrawer`, qui REMPLACE le contenu du drawer courant — donc
 * le panneau de création lui-même, et le fichier que le membre venait d'y déposer. Le ModalManager étant monté AU-DESSUS du DrawerProvider, ce drawer-ci se
 * superpose à celui qui est déjà ouvert au lieu de le remplacer — c'est tout l'intérêt : on peut
 * présenter l'offre sans faire perdre au membre le fichier qu'il était en train de publier.
 *
 * C'est aussi cette enveloppe qui traduit `handleClose` — le nom imposé par le ModalManager — en
 * `handleCancel`, celui d'`OffersModal`. La modale n'a donc pas à connaître deux noms pour la même
 * action, ce qui aurait été une complication durable pour un besoin d'adaptation ponctuel.
 */
const OffersModalGlobal = ({ handleClose = () => {}, ...offersProps }) => {
    // Même règle de gabarit que `openOffersDrawer` (hooks/useRestriction) : depuis la refonte
    // « Premium d'abord » (09/2026), tous les gabarits de blocage sont en colonne, donc small.
    return (
        <Drawer open small closeBtn={false} handleClose={handleClose}>
            <OffersModal {...offersProps} inDrawer handleCancel={handleClose} />
        </Drawer>
    );
};

export default OffersModalGlobal;
